import {
  POLL_FORM_ID,
  type PollModalProps,
} from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/types";
import { Modal } from "@circleco/compass/components/Modal";
import { useRef } from "react";

import { t } from "@/i18n-js/instance";
import type { CompassModalProps } from "@/react/components/SettingsApp/CompassCompat/modalHelpers";

import { insertPollNode } from "../insertPollNode";
import { PollForm } from "./PollForm";
import { usePollForm } from "./usePollForm";

export const PollModalComponent = ({
  editor,
  range,
  addToLocalSgidToObjectMap,
  open,
  onOpenChange,
}: PollModalProps & CompassModalProps) => {
  const initialFocusRef = useRef<HTMLInputElement>(null);

  const {
    canEditOptions,
    isLoadingPollForEdit,
    isSubmitting,
    isValid,
    methods,
    onSubmit,
  } = usePollForm({
    onComplete: poll =>
      insertPollNode({ editor, range, poll, addToLocalSgidToObjectMap }),
  });

  return (
    <Modal.Root
      open={open}
      onOpenChange={onOpenChange}
      size="md"
      disablePointerDismissal
    >
      <Modal.Content>
        <Modal.Header title={t("tiptap.extensions.poll.title")} />
        <Modal.Body>
          <PollForm
            canEditOptions={canEditOptions}
            initialFocusRef={initialFocusRef}
            isLoading={isLoadingPollForEdit}
            methods={methods}
            onSubmit={onSubmit}
          />
        </Modal.Body>
        <Modal.Footer
          primaryAction={{
            type: "submit",
            form: POLL_FORM_ID,
            label: t("tiptap.extensions.poll.save"),
            loading: isSubmitting,
            disabled: isSubmitting || !isValid,
          }}
          secondaryAction={{
            label: t("tiptap.extensions.poll.cancel"),
            onClick: () => onOpenChange(false),
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
